// @flow
import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {AppBanner} from '@homeaway/react-app-banner';
import {Notification} from '@homeaway/react-customer-notification';
import {EdapProvider} from '@homeaway/react-event-tracking';
import type {State as ReduxState} from '../../reducers/index';
import {VRBO_MAD_SERP_PLACEMENT_SURFACE_GATE} from '../../abacus/experiments';
import Experiment, {On, Off} from '@homeaway/react-experiment';
type StateProps = {
    fullLocale: string,
    isAndroid: boolean,
    locale: string,
    siteName: string
};

type Props = StateProps;

const AppDownloadBanner = ({
    fullLocale,
    isAndroid,
    locale,
    siteName
}: Props) => {
    const mobileOS = isAndroid ? 'android' : 'ios';
    return (
        <EdapProvider>
            <Experiment name={VRBO_MAD_SERP_PLACEMENT_SURFACE_GATE}>
                <On>
                    <Notification
                        locale={locale}
                        siteName={siteName}
                        funnelLocation="SEARCH_RESULTS"
                        notificationLocation="PRE_HEADER"
                    />
                </On>
                <Off>
                    <AppBanner
                        locale={fullLocale}
                        mobileOS={mobileOS}
                        page="serp"
                    />
                </Off>
            </Experiment>
        </EdapProvider>
    );
};

const mapStateToProps = ({
    system: {fullLocale, isAndroid, locale, siteName}
}: ReduxState): StateProps => ({
    fullLocale,
    isAndroid,
    locale,
    siteName
});
export default compose(connect(mapStateToProps))(AppDownloadBanner);
